import React, { useEffect, useState } from 'react'
import { withAuthentication } from '../Session'
import { sessions, daySessions } from '../../constants/sessions'
import { GROUPS } from '../../constants/splinterGroups'
import { ROOMS } from '../../constants/rooms'
import { Table } from 'react-bootstrap'
import * as ROUTES from '../../constants/routes'
import map from '../../imgs/map.png'

import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { PLENARY_SESSIONS } from '../../constants/plenary'

const Schedule = (props) => {
  const [selectedDay, setSelectedDay] = useState('')
  const days = [
    'student',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
  ]
  const todayHash = `#${days[new Date().getDay()]}`

  const navigate = useNavigate()
  const { pathname, hash, key } = useLocation()
  useEffect(() => {
    if (hash === '' && new Date() > new Date('2024-06-24')) {
      navigate(`${todayHash}`)
    } else {
      setSelectedDay(hash.slice(1))
    }
    return () => {}
  }, [pathname, hash, key, navigate, todayHash]) // do this on route change

  const DayTabs = () => {
    return (
      <div className='flex flex-wrap justify-center gap-2 '>
        {days.map((day) => (
          <div
            className={`p-2 rounded text-center cursor-pointer ${
              selectedDay !== day
                ? 'bg-[#8c8cd2]'
                : 'bg-[#2d5e99] text-white border-1 border-black'
            }`}
            onClick={() => navigate('#' + day)}
            key={'tab' + day}
          >
            {day === 'student' ? (
              <div>Sunday</div>
            ) : (
              <div>{day.charAt(0).toUpperCase() + day.slice(1)}</div>
            )}
          </div>
        ))}
        <div
          className={`py-2 px-4 rounded text-center cursor-pointer ${
            selectedDay !== 'all'
              ? 'bg-[#8c8cd2]'
              : 'bg-[#2d5e99] text-white border-black border-1'
          }`}
          onClick={() => navigate('#all')}
          key={'all'}
        >
          All
        </div>
      </div>
    )
  }

  return (
    <div>
      <h1 className='text-center py-3 text-5xl'>Schedule</h1>
      <DayTabs />
      <div>
        {days.includes(selectedDay) ? (
          <Day
            dayBlock={daySessions[selectedDay]}
            key={selectedDay}
            day={selectedDay}
          />
        ) : (
          days.map((day, ind) => (
            <Day dayBlock={daySessions[day]} key={ind} day={day} />
          ))
        )}
      </div>
      <div className='flex flex-col justify-center items-center'>
        <h2 className='p2 text-xl'>Map</h2>
        <img src={map} alt='Map of Conference Hall' className='py-2 sm:px-2' />
      </div>
    </div>
  )
}
const Day = ({ dayBlock, day, ...props }) => {
  const makeTable = (dayBlock) => {
    let head = (
      <thead>
        <tr>
          <th className='text-center w-10 lg:w-36'>
            <div className='hidden lg:block'>Central Time</div>
            <div className='block lg:hidden'>CT</div>
          </th>
          <th></th>
          <th className='text-center w-10 sm:w-32'>Room</th>
        </tr>
      </thead>
    )
    let body = []
    for (let block of dayBlock) {
      let blockSessions = block.map((id) => sessions[id])
      let oneLineTimeBlock =
        block.length === 1 &&
        !!blockSessions[0].name &&
        !blockSessions[0].topicL
      if (oneLineTimeBlock) {
        let link = ''
        if (blockSessions[0]['groups'].length) {
          if (blockSessions[0]['groups'][0] === 'plenary') {
            link = ROUTES.PLENARY
          } else if (blockSessions[0]['groups'][0] === 'student') {
            link = ROUTES.STUDENTSCHEDULE
          } else if (blockSessions[0]['groups'][0] === 'burnout') {
            link = '/communitycare'
          }
        }
        let sessionName = ''
        if (link === ROUTES.PLENARY) {
          sessionName = PLENARY_SESSIONS[blockSessions[0].id].name
        } else {
          sessionName = blockSessions[0]['name']
        }

        let row = (
          <tr key={blockSessions[0].id}>
            <td>{blockSessions[0].time}</td>
            <td className=''>
              {link ? (
                <NavLink className='text-blue-500 hover:text-red-500' to={link}>
                  {blockSessions[0]['name'] ? (
                    <strong>{sessionName}</strong>
                  ) : (
                    blockSessions[0]['topicL']
                  )}
                </NavLink>
              ) : (
                <span>
                  {blockSessions[0]['name'] ? (
                    <strong>{blockSessions[0]['name']}</strong>
                  ) : (
                    blockSessions[0]['topicL']
                  )}
                </span>
              )}
            </td>
            <td>
              <RoomKey room={blockSessions[0].room} />
            </td>
          </tr>
        )
        body.push(row)
        continue
      }
      let overlappingTimesTimeBlock = !blockSessions.every(
        (sess) => sess.time === blockSessions[0].time
      )
      if (overlappingTimesTimeBlock) {
        let headerRow = (
          <tr key={blockSessions[0].id + 'header'}>
            <td></td>
            <td>
              <strong>{blockSessions[0]['name']}</strong>
            </td>
            <td>{}</td>
          </tr>
        )
        body.push(headerRow)
        for (let session of blockSessions) {
          const groupies = session.groups.flatMap((g, i) => [
            <LinkToGroup
              group={g}
              sessionId={session.id}
              key={g + session.id}
            />,
            <span>{' - '}</span>,
          ])
          let row = (
            <tr key={session.id}>
              <td>{session.time}</td>
              <td>
                {groupies}
                {session.topicL && session.topicL}
              </td>
              <td>
                <RoomKey room={session.room} />
              </td>
            </tr>
          )

          body.push(row)
        }

        continue
      }

      if (blockSessions[0]) {
      }
      let headerRow = (
        <tr key={blockSessions[0].id + 'header'}>
          <td>{blockSessions[0].time}</td>
          <td>
            <strong>{blockSessions[0]['name']}</strong>
          </td>
          <td>{}</td>
        </tr>
      )
      body.push(headerRow)
      const LinkToGroup = ({ group, sessionId }) => {
        return GROUPS[group] ? (
          <NavLink
            className='text-blue-500 hover:text-red-500'
            to={`/groups/${group}#${sessionId}`}
          >
            {group}
          </NavLink>
        ) : (
          <span key={group + 'span'}>{group}</span>
        )
      }
      for (let session of blockSessions) {
        if (!session.hasOwnProperty('plenId')) {
          const groupies = session.groups.flatMap((g, i) => [
            <LinkToGroup
              group={g}
              sessionId={session.id}
              key={g + session.id}
            />,
            <span>{' - '}</span>,
          ])
          let row = (
            <tr key={session.id}>
              <td></td>
              <td>
                {groupies}
                {session.topicL && session.topicL}
              </td>
              <td>
                <RoomKey room={session.room} />
              </td>
            </tr>
          )

          body.push(row)
        } else {
          const plenSession = PLENARY_SESSIONS[session.id]
          let row = (
            <tr key={session.id}>
              <td></td>
              <td>
                <NavLink
                  to={ROUTES.PLENARY}
                  className='text-blue-500 hover:text-red-500'
                >
                  {plenSession.name.split(' ').slice(1).join(' ')}
                </NavLink>
              </td>
              <td>
                <RoomKey room={plenSession.room} />
              </td>
            </tr>
          )
          body.push(row)
        }
      }
    }
    return (
      <div className='sm:px-2'>
        <Table bordered hover size='sm'>
          {head}
          <tbody>{body}</tbody>
        </Table>
      </div>
    )
  }
  return (
    <div id={day}>
      <div className='text-center text-2xl p-3'>
        {sessions[dayBlock[0][0]].date}
      </div>
      {makeTable(dayBlock)}
    </div>
  )
}

// const Day = ({ dayBlock, day, ...props }) => {
//   const makeTable = (timeBlocks, day) => {
//     let head = (
//       <thead>
//         <tr>
//           <th className='text-center w-10 lg:w-36'>
//             <div className='hidden lg:block'>Central Time</div>
//             <div className='block lg:hidden'>CT</div>
//           </th>
//           <th></th>
//           <th className='text-center w-10 sm:w-32'>Room</th>
//         </tr>
//       </thead>
//     )
//     let body = []
//     timeBlocks.forEach((block, ind) => {
//       let oneLineTimeBlock = block.length === 1;
//       let blockSessions = block.map(id => sessions[id])
//       if(oneLineTimeBlock){
//         let row = <tr key={blockSessions[0].id}><td>{block.time}</td><td>{blockSessions['name']}</td></tr>
//       }
//       body.push(
//         <tr key={ind}>
//           <td>{block.time}</td>
//           {dayBlock.dayInfo.dayName === 'student' &&
//           block.name.includes('Student') ? (
//             <td>
//               <strong>
//                 <NavLink
//                   className='text-blue-500 hover:text-red-500'
//                   to={'/' + ROUTES.STUDENTSCHEDULE}
//                 >
//                   {block.name}
//                 </NavLink>
//               </strong>
//             </td>
//           ) : block.name.includes('Plenary') ? (
//             <td>
//               <strong>
//                 <NavLink
//                   className='text-blue-500 hover:text-red-500'
//                   to={'/' + ROUTES.PLENARY}
//                 >
//                   {block.name}
//                 </NavLink>
//               </strong>
//             </td>
//           ) : block.name.includes('SBCCI') ? (
//             <td>
//               <strong>
//                 <NavLink
//                   className='text-blue-500 hover:text-red-500'
//                   to={'/sbcci'}
//                 >
//                   {block.name}
//                 </NavLink>
//               </strong>
//             </td>
//           ) : block.name.includes('Memorial') ? (
//             <td>
//               <strong>
//                 <NavLink
//                   className='text-blue-500 hover:text-red-500'
//                   to={'/jenngannon'}
//                 >
//                   {block.name}
//                 </NavLink>
//               </strong>
//             </td>
//           ) : block.name.includes('Student Rep') ? (
//             <td>
//               <strong>
//                 <NavLink
//                   className='text-blue-500 hover:text-red-500'
//                   to={'/studentRep'}
//                 >
//                   {block.name}
//                 </NavLink>
//               </strong>
//             </td>
//           ) : (
//             <td>
//               <strong>{block.name}</strong>
//             </td>
//           )}
//           <td>
//             {somethingInLastColOfHeader && (
//               <h3>
//                 {block.name.includes('Poster') ||
//                 block.name.includes('GEMEE') ||
//                 block.name.includes('Banquet') ||
//                 block.name.includes('Social') ? (
//                   <span>
//                     {block.rooms && block.rooms.length && (
//                       <RoomKey room={block.rooms[0]} />
//                     )}
//                   </span>
//                 ) : block.name.includes('Icebreaker') ? (
//                   <span>
//                     <h6>{block.rooms}</h6>
//                   </span>
//                 ) : (
//                   <span>
//                     {block?.rooms?.length ? (
//                       <span>
//                         {block.rooms && block.rooms.length && (
//                           <RoomKey room={block.rooms[0]} />
//                         )}
//                       </span>
//                     ) : (
//                       <></>
//                     )}
//                   </span>
//                 )}
//               </h3>
//             )}
//           </td>
//         </tr>
//       )
//       block.groups.forEach((group, ind) => {
//         if (
//           !block.name.includes('Plenary') &&
//           dayBlock.dayInfo.dayName !== 'sunday' &&
//           !block.name.includes('Student Rep') &&
//           !block.name.includes('GEMEE') &&
//           !block.groups.includes('SHINE')
//         ) {
//           body.push(
//             <tr key={block.name + group + ind}>
//               <td></td>
//               <td>
//                 {typeof group === 'string' ? (
//                   GROUPS[group] ? (
//                     <span>
//                       <NavLink
//                         className='text-blue-500 hover:text-red-500'
//                         to={`/groups/${group}#${block.id}`}
//                       >
//                         <div className='indent-[-2em] pl-[2em]'>
//                           {GROUPS[group] && GROUPS[group].longName}
//                         </div>
//                       </NavLink>
//                     </span>
//                   ) : group.includes('Poster') ? (
//                     <NavLink
//                       className='text-blue-500 hover:text-red-500'
//                       to={`/posters?focusGroup=${group.split(' ')[0]}`}
//                     >
//                       {group}
//                     </NavLink>
//                   ) : (
//                     group
//                   )
//                 ) : (
//                   <div>
//                     {group.map((group) => {
//                       if (
//                         block.id &&
//                         !GROUPS[group].blocks.includes(block.id)
//                       ) {
//                       }
//                       return GROUPS[group] ? (
//                         <div key={group}>
//                           <span>
//                             <NavLink
//                               className='text-blue-500 hover:text-red-500'
//                               to={`/groups/${group}#${block.id}`}
//                             >
//                               <div className='pl-[2em] indent-[-2em]'>
//                                 {GROUPS[group].longName}
//                               </div>
//                             </NavLink>
//                           </span>
//                         </div>
//                       ) : (
//                         <p key={group}>{group}</p>
//                       )
//                     })}
//                   </div>
//                 )}
//               </td>
//               <td>
//                 <h3>
//                   <RoomKey room={block.rooms[ind]} />
//                 </h3>
//               </td>
//             </tr>
//           )
//         }
//       })
//     })

//     return (
//       <div className='sm:px-2'>
//         <Table bordered hover size='sm'>
//           {head}
//           <tbody>{body}</tbody>
//         </Table>
//       </div>
//     )
//   }
//   return (
//     <div id={day}>
//       <div className='text-center text-2xl p-3'>
//         {dayBlock.dayInfo.date && dayBlock.dayInfo.date}
//       </div>
//       {makeTable(blocks, dayBlock.dayInfo.dayName)}
//     </div>
//   )
// }

const RoomKey = ({ room }) => {
  const key = ROOMS[room] || { title: '', displayShort: '' }
  return (
    <div
      className='flex justify-center items-center h-full text-center'
      title={key.title}
    >
      <div className='block sm:hidden'>{key.displayShort}</div>
      <div className='hidden sm:block'>{key.title}</div>
    </div>
  )
}

export default withAuthentication(Schedule)
